// src/pages/empleos/DetallePublicoEmpleo.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./detallepublicoempleo.css";

function DetallePublicoEmpleo() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);

  useEffect(() => {
    // Obtenemos los empleos guardados en localStorage
    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    // Buscamos el empleo cuyo id coincida con jobId (convertido a string)
    const foundJob = storedJobs.find((j) => j.id.toString() === jobId);
    if (foundJob) {
      // Si deseas restringir para que solo se muestren los publicados, podrías hacer:
      // if (foundJob.status === "Publicado") { setJob(foundJob); }
      // Pero en este ejemplo mostramos cualquiera que se encuentre.
      setJob(foundJob);
    }
  }, [jobId]);

  if (!job) {
    return (
      <div className="public-job-container">
        <div className="public-job-card">
          <h2>Empleo no encontrado</h2>
          <button onClick={() => navigate(-1)} className="btn-back">
            Volver
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="public-job-container">
      <div className="public-job-card">
        <h2 className="job-title">{job.title}</h2>
        <p><strong>Categoría:</strong> {job.category} / {job.subcategory}</p>
        <p><strong>Estado (EE.UU.):</strong> {job.stateUS}</p>
        <p><strong>Ciudad:</strong> {job.city}</p>
        <p><strong>Zip Code:</strong> {job.zipCode}</p>
        <p><strong>Dirección Completa:</strong> {job.address}</p>
        <p><strong>Salario:</strong> {job.salary}</p>
        <p><strong>Modalidad:</strong> {job.modality}</p>
        <p><strong>Idioma:</strong> {job.workLanguage}</p>
        <p><strong>Requisito de Visa:</strong> {job.visaRequirement}</p>
        <p><strong>Tipo de Trabajo:</strong> {job.jobType}</p>
        <p><strong>Beneficios:</strong> {job.benefits}</p>
        <p><strong>Requisitos:</strong> {job.requirements}</p>
        {job.phone && <p><strong>Teléfono de Contacto:</strong> {job.phone}</p>}
        {job.contactEmail && <p><strong>Correo de Contacto:</strong> {job.contactEmail}</p>}
        <div className="public-job-actions">
          <button onClick={() => navigate(-1)} className="btn-back">Volver</button>
          {/* Los botones "Aplicar" y "Favorito" se mostrarían si el usuario es "user" */}
          <button className="btn-apply">Aplicar</button>
          <button className="btn-favorite">Favorito</button>
        </div>
      </div>
    </div>
  );
}

export default DetallePublicoEmpleo;